import { render, staticRenderFns } from "./GalleryCanvaPhotos.vue?vue&type=template&id=8d133678&scoped=true"
import script from "./GalleryCanvaPhotos.vue?vue&type=script&lang=js"
export * from "./GalleryCanvaPhotos.vue?vue&type=script&lang=js"
import style0 from "./GalleryCanvaPhotos.scss?vue&type=style&index=0&id=8d133678&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d133678",
  null
  
)

export default component.exports